module.exports = __webpack_public_path__ + "img/SketchPng884f9208ad222010878858fc8cb5e423234b83a1c9ddae1c598d3c8f9197f38f.bebb0e68.png";